import { render, staticRenderFns } from "./HelpBlock.vue?vue&type=template&id=1bb9b2a0&scoped=true"
import script from "./HelpBlock.vue?vue&type=script&lang=js"
export * from "./HelpBlock.vue?vue&type=script&lang=js"
import style0 from "./HelpBlock.vue?vue&type=style&index=0&id=1bb9b2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb9b2a0",
  null
  
)

export default component.exports